import { Component, OnInit, Output, EventEmitter, Input, AfterContentInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core';
import { ContactModel } from '@models/index';
import { emptyContactModel } from '@utilities/data-utils';
import { AddContactMethod } from '@enums/addContactMethod.enum';
import * as parser from 'papaparse';
import Swal from 'sweetalert2';
import { BehaviorSubject, never, Subscription } from 'rxjs';
import { tap, filter, map } from 'rxjs/operators';
import { CampaignsFacadeService } from '@services/campaigns/campaigns-facade.service';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';

@Component({
  selector: 'bulk-add-form',
  templateUrl: './bulk-add-form.component.html',
  styleUrls: ['./bulk-add-form.component.sass']
})
export class BulkAddFormComponent implements OnInit, AfterContentInit {
  
  @ViewChild('file') fileInput: HTMLInputElement;

  @Output() newBulkFile = new EventEmitter<ContactModel[]>();
  @Output() loadingFile = new EventEmitter<boolean>();
  @Output() campaignIdEmit = new EventEmitter<string>();
  @Input() cleanInput$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  bulkAddForm: FormGroup;
  chosenFile: string;
  records: ContactModel[] = [];
  csvRecords: Object[];
  csvHeaders: string[] = [];
  csvOrganized: Object[] = [];
  headers: string[] = ['name', 'lastName', 'email', 'phoneNumber'];
  showHeaderComparison: boolean = false;
  campaigns$ = this.campaignsFacadeService.getLocationCampaignsBasicInfo$()
    .pipe(
      map(items => items.filter(item => !item.isDisabledMultiCampaign))
    )
  selectedLocation$ = this.locationsFacadeService.getCurrentLocation$();
  campaignId: string = ''
  _subs: Subscription = never().subscribe();
  selectedCampaign: string

  constructor(
    private fb: FormBuilder,
    private campaignsFacadeService: CampaignsFacadeService,
    private locationsFacadeService: LocationsFacadeService
  ) {}

  ngOnInit() {

    this._subs.add(
      this.selectedLocation$.subscribe(location => {
        this.campaignId = location.preferredCampaign
        this.campaignIdEmit.emit(this.campaignId)
        this.selectedCampaign = location.preferredCampaign
      })
    );

  }

  ngAfterContentInit() {
    this.bulkAddForm = this.fb.group({
      file: ['', Validators.required]
    }, {
      validator: (formControl) => formControl.value.file < 0
        ? { invalid: true } : null
    });

    this.cleanInput$.pipe(
      filter(value => value)
    ).subscribe(clean => {
      console.log("cleanInput");

      this.bulkAddForm.reset()
      this.chosenFile = ''
    })
  }

  onSubmit() {
    console.log("CampaignId ", this.campaignId);
    this.newBulkFile.emit(this.records.map(record => ({ ...record, campaignId: this.campaignId })));
  }
  convertCamelCase(column) {
    let wordsSeparates = column.replace(/([a-z])([A-Z])/g, '$1 $2')
    if (wordsSeparates == 'name') wordsSeparates = 'first name'
    return wordsSeparates.charAt(0).toUpperCase() + wordsSeparates.slice(1);
  }
  onChangeSelects(event: { originalEvent: Event, value: string }, i: number) {
    if (event.value !== "") {
      this.csvOrganized = this.csvRecords.map((record, index) => {
        const tempVal = { ...this.csvOrganized[index] }
        tempVal[this.headers[i]] = record[event.value]
        return tempVal
      })
    }
  }
  isCSVFile(file: any) {
    return file ? file.name.endsWith('.csv') : false;
  }
  getHeaderArray(csvRecordsArr: any) {
    let headers = csvRecordsArr[0].split(',');
    let headerArray = [];

    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }
  getDataRecordsArrayFromCSVFile(csvRecords: any, header: any) {
    let dataArr = []
    csvRecords.forEach(element => {
      let csvContactRecord: ContactModel = emptyContactModel();
      csvContactRecord.name = element.name ? element.name : '';
      csvContactRecord.lastName = element.lastName ? element.lastName : '';
      csvContactRecord.email = element.email ? element.email.replace(/\"/g, '') : '';
      csvContactRecord.phoneNumber = element.phoneNumber ? element.phoneNumber : '';
      dataArr.push(csvContactRecord);
    })
    return (dataArr.map(item => ({ ...item, addMethod: AddContactMethod.bulkAdd })));
  }
  fileChange($event: any): void {
    var files = $event.srcElement.files;

    if (this.isCSVFile(files[0])) {
      var input = $event.target;
      var reader = new FileReader();
      reader.readAsText(input.files[0]);

      reader.onload = () => {
        let csvData = reader.result;
        parser.parse(files[0], {
          header: true,
          skipEmptyLines: true,
          complete: (result, file) => {
            if (result.errors.length == 0) {
              this.csvRecords = result.data;
              this.csvHeaders = result.meta.fields
              this.csvOrganized = [...this.csvRecords]
              this.showHeaderComparison = true;
              this.loadingFile.emit(true);
            }
            else {
              let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
              this.csvHeaders = this.getHeaderArray(csvRecordsArray);
              const csvFilter = csvRecordsArray.filter((value, index) => {
                const splitValue = value.split(",")
                const valuesTrim = splitValue.map(value => value.trim())
                return index !== 0 && !(valuesTrim.every(value => value === ""))
              })
              this.csvRecords = csvFilter.map((value, _) => {
                const splitValue = value.split(",")
                let obj = Object.assign({}, splitValue)
                this.csvHeaders.forEach((col, inx) => {
                  obj[`${col}`] = obj[inx]
                  delete obj[inx]
                })
                return obj
              })
              this.csvOrganized = [...this.csvRecords]
              this.showHeaderComparison = true;
              this.loadingFile.emit(true);
            }
          }
        });
      }
    }
    else {
      Swal.fire({
        title: 'Unsupported File Type',
        text: 'The format of the file you are using is not supported. Please save your file in a CSV format and try again.',
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'OK'
      })
      this.newBulkFile.emit([]);
    }
  }
  validateNonSelectedFields() {
    const selectCollection = document.getElementsByTagName("select")
    const valuesArray = [].slice.call(selectCollection).map(sel => sel.value)
    const noEmptyValues = valuesArray.filter(val => val !== "")

    noEmptyValues.length < valuesArray.length
      ? Swal.fire({
        title: 'Empty Values',
        text: `You’ve chosen not to map some optional fields for upload. Do you want to continue?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Continue!',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.showdataTable(noEmptyValues)
        }
      })
      : this.showdataTable(noEmptyValues)
  }

  showdataTable(arrayHeaders) {
    let repeatValue = '';
    arrayHeaders.forEach(element => {
      if (arrayHeaders.filter(val => val === element).length > 1) {
        repeatValue = element
        return false;
      }
    });
    if (repeatValue !== '') {
      Swal.fire({
        title: 'Repeated Values',
        text: `You are repeting ${repeatValue} on headers. Please select a different header`,
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'OK'
      })
      return false;
    } else {
      this.csvOrganized.forEach((record) => {
        const keys = Object.keys(record)
        keys.forEach((key) => {
          if (this.headers.filter(header => header == key).length == 0) delete record[`${key}`]
        })
      })
      this.csvOrganized = this.csvOrganized
        .map((item: ContactModel) => ({
          ...item,
          name: item.name ? item.name.replace(/["]/g, '') : '',
          lastName: item.lastName ? item.lastName.replace(/["]/g, '') : '',
          email: item.email ? item.email.toLowerCase().trim() : ''
        })
        )

      const contactRecords = this.getDataRecordsArrayFromCSVFile(this.csvOrganized, this.csvHeaders);
      this.showHeaderComparison = false
      this.newBulkFile.emit(contactRecords.map(record => ({ ...record, campaignId: this.campaignId })));
    }
  }
  changeName(event) {
    this.chosenFile = this.bulkAddForm.value.file.replace(/C:\\fakepath\\/g, '') ? this.bulkAddForm.value.file.replace(/C:\\fakepath\\/g, '') : ''
  }

  changeContactCampaign(campaignId: string) {
    this.campaignId = campaignId
    this.campaignIdEmit.emit(this.campaignId)
  }

  fileNameChanged(event: Event) {
    event.stopPropagation()
    this.fileInput.files = (event.target as HTMLInputElement).files
    this.fileChange({ ...event, srcElement: this.fileInput })
  }
}
